import { render, staticRenderFns } from "./order_opr.vue?vue&type=template&id=4f756d5f&"
import script from "./order_opr.vue?vue&type=script&lang=js&"
export * from "./order_opr.vue?vue&type=script&lang=js&"
import style0 from "./order_opr.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports